import { useTranslation } from 'react-i18next'

import EditWidgetForm from './EditWidgetForm'
import Widget from '../Widget'

export const useGROUPED_EVENTS_BY_REASON_CONFIG = () => {
  const { t } = useTranslation('common')

  return {
    id: 'GROUPED_EVENTS_BY_REASON',
    name: t('widgets.groupedEventsByReason.name'),
    color: 'darkGreen',
    icon: 'RiPieChart2Line',
    categories: [t('widgets.groupedEventsByReason.category')],
    description: t('widgets.groupedEventsByReason.description'),
    previewWidth: '65%',

    initialState: {
      size: { width: 50, height: 400 },
      data: { initialState: { status: { id: 10, name: t('widgets.canceled') } }, presentation: 'pie' }
    },

    Presentation: Widget,
    Form: EditWidgetForm
  }
}
